import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    Input,
} from '@angular/core';
import {
    EntityChangeTrackingDto,
    IChangeTrackingFacade,
    IEntity,
    ISearchFields,
} from '@pf/shared-common';
import {
    computeChangedFields,
    computeChangeText,
} from '@pf/shared/util-platform';

import { TableColumnBuilder } from '@pf/shared-ui';

@Component({
    selector: 'platform-detailed-history-view',
    templateUrl: './detailed-history-view.component.html',
    styleUrls: ['./detailed-history-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailedHistoryViewComponent {
    private _cdr = inject(ChangeDetectorRef);
    @Input() changeTrackingFacade!: IChangeTrackingFacade<IEntity>;
    @Input() entityName!: string;

    searchField: ISearchFields<EntityChangeTrackingDto<IEntity>> = ['entity'];

    columns = new TableColumnBuilder<EntityChangeTrackingDto<IEntity>>()
        .withColumn({
            field: 'changes',
            headerName: 'Changes',
            valueFormatter: (_, record: EntityChangeTrackingDto<IEntity>) => {
                return record.changes?.length
                    ? computeChangeText(record.changes) +
                          ' - ' +
                          computeChangedFields(record.changes)
                    : '';
            },
        })
        .withColumn({
            field: 'userEmail',
            headerName: 'User',
        })
        .withColumn({
            field: 'createdDate',
            headerName: 'Time Changed',
            type: 'datetime',
        }).columns;

    onDataChanged() {
        this._cdr.markForCheck();
    }
}
